<template>
  <div>
    <Frontendlayout>
      <section class="hero_in tours">
        <div class="wrapper">
          <div class="container">
            <h1 class="fadeInUp"><span></span>My Profile</h1>
          </div>
        </div>
      </section>
      <!--/hero_in-->

      <div class="container-fluid">
        <div class="row">
          <Sidebar />
          <!-- /aside -->

          <div class="col-lg-10">
            <div class="isotope-wrapper">
              <div class="box_general padding_bottom">
                <div class="header_box version_2">
                  <div class="row">
                    <div class="col-lg-3">
                      <div class="card">
                        <div class="card-body">
                          <img
                            v-if="profileDetails.profile_img != ''"
                            :src="
                              `https://peekzy.in/backend/public/assets/uploads/` +
                              profileDetails.profile_img
                            "
                          />
                          <i class="fa fa-user" v-else></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-9">
                      <div class="card">
                        <div class="card-body">
                          <h3>
                            {{ profileDetails.first_name }}
                            {{ profileDetails.last_name }}
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <form @submit.prevent="updateProfile()" method="post">
                  <div class="row">
                    <div class="col-md-12 add_top_30">
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>First Name</label>
                            <input
                              type="text"
                              class="form-control"
                              v-model="profileDetails.first_name"
                              placeholder="First name"
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Last Name</label>
                            <input
                              type="text"
                              class="form-control"
                              v-model="profileDetails.last_name"
                              placeholder="Last name"
                            />
                          </div>
                        </div>

                        <div class="col-md-6" v-show="roleId == 2">
                          <div class="form-group">
                            <label>Company Name</label>
                            <input
                              type="text"
                              class="form-control"
                              v-model="profileDetails.company_name"
                              placeholder="Shop name"
                            />
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Email</label>
                            <input
                              type="text"
                              readonly
                              class="form-control"
                              v-model="profileDetails.primary_email"
                              placeholder="Email 2"
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Mobile No</label>
                            <input
                              type="text"
                              class="form-control"
                              v-model="profileDetails.mobile_1"
                              placeholder="Mobile 1"
                            />
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="form-group">
                            <label v-show="roleId == 2"
                              >Date of Incorporation</label
                            >
                            <label v-show="roleId == 3">Date of Birth</label>
                            <date-picker
                              v-model="profileDetails.dob"
                              :config="datepickerconfig"
                            ></date-picker>
                            <!-- <input
                              type="date"
                              class="form-control"
                              v-model="profileDetails.dob"
                            /> -->
                          </div>
                        </div>
                        <div class="col-md-6" v-show="roleId == 2">
                          <div class="form-group">
                            <label>GST</label>
                            <input
                              type="text"
                              class="form-control"
                              v-model="profileDetails.gst_no"
                              placeholder="GST"
                            />
                          </div>
                        </div>
                        <div class="col-md-6" v-show="roleId == 2">
                          <div class="form-group">
                            <label>PAN</label>
                            <input
                              type="text"
                              class="form-control"
                              v-model="profileDetails.pan_no"
                            />
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Your Profile Photo</label>

                            <div class="form-group">
                              <div v-if="!image">
                                <input
                                  class="form-control"
                                  type="file"
                                  @change="onFileChange"
                                />
                              </div>
                              <div v-else class="show_img">
                                <img :src="image" height="100px" />
                                <button @click="removeImage">
                                  Remove image
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6" v-show="roleId == 2">
                          <div class="form-group">
                            <label>Upload Gallery Photos</label>
                            <div class="form-group">
                              <div>
                                <input
                                  class="form-control"
                                  ref="file"
                                  multiple
                                  type="file"
                                  @change="onGalleryChange"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div
                              class="col-md-2"
                              v-for="galleryimages in galleryimage"
                              :key="galleryimages.id"
                            >
                              <img
                                v-if="galleryimages.type == 'image'"
                                :src="`https://peekzy.in/backend/public/assets/user/vendorgallery/${galleryimages.link}`"
                                style="width: 100%"
                                class="mt-1"
                              />
                              <a
                                href="javascript:void(0);"
                                class="ml-3"
                                @click="
                                  removeImage(
                                    galleryimages.id,
                                    galleryimages.link
                                  )
                                "
                                ><i class="fa fa-trash"></i
                              ></a>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-4" v-show="roleId == 2">
                          <div class="form-group">
                            <label>Video Link 1</label>
                            <input
                              type="url"
                              class="form-control"
                              v-model="profileDetails.video1"
                              placeholder="Video Url..."
                            />
                          </div>
                        </div>
                        <div class="col-md-4" v-show="roleId == 2">
                          <div class="form-group">
                            <label>Video Link 2</label>
                            <input
                              type="url"
                              class="form-control"
                              v-model="profileDetails.video2"
                              placeholder="Video Url..."
                            />
                          </div>
                        </div>
                        <div class="col-md-4" v-show="roleId == 2">
                          <div class="form-group">
                            <label>Video Link 3</label>
                            <input
                              type="url"
                              class="form-control"
                              v-model="profileDetails.video3"
                              placeholder="Video Url..."
                            />
                          </div>
                        </div>

                        <div class="col-md-12" v-show="roleId == 2">
                          <div class="form-group">
                            <label>About Yorself</label>
                            <ckeditor
                              :editor="editor"
                              v-model="profileDetails.about_us"
                              :config="editorConfig"
                            ></ckeditor>
                          </div>
                        </div>
                      </div>
                      <!-- /row-->

                      <!-- /row-->
                      <div class="row">
                        <div class="col-md-12">
                          <alert
                            transition="slide-y-transition"
                            v-if="msg"
                            :msg="msg"
                            :classAlert="classAlert"
                          ></alert>

                          <div id="pass-info" class="clearfix"></div>
                          <center>
                            <button
                              type="submit"
                              class="btn_1 rounded add_top_30 mb-3"
                            >
                              Update
                            </button>
                          </center>
                        </div>
                      </div>
                      <!-- /row-->
                    </div>
                  </div>
                </form>
              </div>
              <!-- /row -->
            </div>
            <!-- /isotope-wrapper -->
          </div>
          <!-- /col -->
        </div>
      </div>

      <!-- /container -->
      <!-- /bg_color_1 -->
    </Frontendlayout>
  </div>
</template>

<script>
// import axios from 'axios'
import Alert from "@/cmps/Alert";
import API from "@/services/index";
import Frontendlayout from "@/layouts/Frontendlayout.vue";
import Sidebar from "@/layouts/Sidebar.vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import moment from "moment";

export default {
  data() {
    return {
      roleId: localStorage.getItem("role_id"),
      token: "Bearer " + localStorage.getItem("token"),
      msg: null,
      classAlert: null,
      profileDetails: [],
      profile_img: null,
      image: "",
      editor: ClassicEditor,
      editorData: "<p>Content of the editor.</p>",
      editorConfig: {
        // The configuration of the editor.
        height: "500px",
      },

      datepickerconfig: {
        format: "DD/MM/YYYY",
        useCurrent: false,
      },
      galleryimage: [],
      login_id: null,
    };
  },
  components: {
    Frontendlayout,
    Sidebar,
    Alert,
  },
  beforeMount() {
    this.checkToken();
    this.getProfiledetails();
  },

  methods: {
    checkToken() {
      //alert(this.token);
      if (this.token == "Bearer " + null) {
        this.$router.push("/signin");
      }
    },

    getProfiledetails() {
      const form = new FormData();
      form.append("role_id", this.roleId);

      API.post("profile/role_wise_userDetails", form, {
        headers: { Authorization: this.token },
      })
        .then((response) => {
          this.profileDetails = response.data.data[0];
          this.login_id = response.data.data[0].id;
          //alert(this.frontEndDateFormat(this.profileDetails.dob));
          this.profileDetails.dob = moment(
            this.profileDetails.dob,
            "YYYY-MM-DD"
          );
          this.galleryimage = response.data.data.vendorgallery;
          //alert(this.profileDetails.dob);
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    removeImage(id, name) {
      const form = new FormData();
      form.append("role_id", this.roleId);
      form.append("id", window.btoa(id));
      form.append("name", name);
      API.post("profile/removeimage", form, {
        headers: { Authorization: this.token },
      })
        .then((response) => {
          if (response.data.status == 200) {
            this.getProfiledetails();
          } else {
            this.msg = response.data.messages;
            setTimeout(() => {
              this.msg = '';
            }, 3000);
            this.classAlert = "danger";
          }
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    frontEndDateFormat(date) {
      //alert(moment(date, "YYYY-MM-DD").format("DD-MM-YYYY"));
      return moment(date, "YYYY-MM-DD").format("DD-MM-YYYY");
    },
    backEndDateFormat: function (date) {
      return moment(date, "DD-MM-YYYY").format("YYYY-MM-DD");
    },

    updateProfile() {
      // alert(this.profileDetails.first_name);
      //alert(this.profileDetails.dob);
      const form = new FormData();
      form.append("role_id", this.roleId);
      form.append("first_name", this.profileDetails.first_name);
      form.append("last_name", this.profileDetails.last_name);
      form.append("company_name", this.profileDetails.company_name);
      form.append("secondary_email", this.profileDetails.secondary_email);
      form.append("mobile_1", this.profileDetails.mobile_1);
      form.append("dob", this.profileDetails.dob);
      form.append("gst_no", this.profileDetails.gst_no);
      form.append("pan_no", this.profileDetails.pan_no);
      form.append("about_us", this.profileDetails.about_us);
      form.append("video1", this.profileDetails.video1);
      form.append("video2", this.profileDetails.video2);
      form.append("video3", this.profileDetails.video3);
      if (this.profile_img != null) {
        form.append("profile_img", this.profile_img);
      } else {
        form.append("profile_img", this.profileDetails.profile_img);
      }

      console.log(this.profile_img);
      API.post("/profile/update", form, {
        headers: { Authorization: this.token },
      })
        .then((res) => {
          console.log("message=" + res.data);
          if (res.data.status == 200) {
            this.msg = "Your Profile updated Successfully";
            setTimeout(() => {
              this.msg = '';
            }, 3000);
            this.classAlert = "success";
            // router.push("/");
          } else {
            this.msg = res.data.messages;
            this.classAlert = "danger";
          }
        })
        .catch((err) => {
          this.msg = err.response.data.messages.error;
          setTimeout(() => {
              this.msg = '';
            }, 3000);
          this.classAlert = "danger";
        });
      //axios
    },

    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
      this.profile_img = files[0];
    },
    onGalleryChange() {
      var files = this.$refs.file.files;

      const form = new FormData();
      for (let i = 0; i < files.length; i++) {
        form.append("image[]", files[i]);
      }
      form.append("login_id", this.login_id);
      API.post("/profile/vendorgallery", form, {
        headers: { Authorization: this.token },
      })
        .then((res) => {
          if (res.data.status == 200) {
            this.msg = res.data.messages;
            this.classAlert = "success";
            this.getProfiledetails();
          } else {
            this.msg = res.data.messages;
            setTimeout(() => {
              this.msg = '';
            }, 3000);
            this.classAlert = "danger";
          }
        })
        .catch((err) => {
          this.msg = err.response.data.messages.error;
          setTimeout(() => {
              this.msg = '';
            }, 3000);
          this.classAlert = "danger";
        });
    },
    createImage(file) {
      this.image = new Image();
      var reader = new FileReader();

      reader.onload = (e) => {
        this.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
  },
};
</script>
<style  scoped>
@import "../../public/frontend/vendor/dropzone.css";

.show_img,
.header_box img {
  width: 100%;
}
</style>